import { TeacherRole, TeacherTag } from "../gql/graphql.ts";

export const teacherRoleLabels: Record<TeacherRole, string> = {
  [TeacherRole.Teacher]: "Teacher",
  [TeacherRole.NormaStaff]: "Staff Norma",
};

export const teacherTagLabels: Record<TeacherTag, string> = {
  [TeacherTag.OnboardingLive]: "Live Onboarding",
};
